import { render, staticRenderFns } from "./Collections.tpl?vue&type=template&id=cdbbe6fc&"
import script from "./Collections.vue?vue&type=script&lang=ts&"
export * from "./Collections.vue?vue&type=script&lang=ts&"
import style0 from "./Collections.styl?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports